export default "/images/vendor/flag-icons/flags/1x1/gd.svg?8c11ad0dbdb6d2b65204e45abec5f20f";